export default __webpack_public_path__ + "static/media/yahoo.ef143993.svg";